import React, { useState } from 'react';
import { Form, Row, Col, Button, InputGroup } from 'react-bootstrap';
import { FaUser, FaPhoneAlt, FaEnvelope, FaRegCommentDots, FaTag } from 'react-icons/fa';
import './contactform.css';

const ContactForm = () => {
  const [notificationConsent, setNotificationConsent] = useState(false);
  const [consentError, setConsentError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!notificationConsent) {
      setConsentError('Please authorise notifications to continue');
      return;
    }

    setConsentError('');
    // Form submission logic can be added here
  };

  return (
    <Form className="contact-form p-4 shadow-sm rounded" onSubmit={handleSubmit} noValidate>
      <h3 className="contactform-heading mb-4 text-center">Get in Touch</h3>

      <Row className="mb-3">
        <Col xs={12} md={6}>
          <InputGroup className="mb-3">
            <InputGroup.Text className="form-icon"><FaUser /></InputGroup.Text>
            <Form.Control type="text" placeholder="Enter your name" />
          </InputGroup>
        </Col>
        <Col xs={12} md={6}>
          <InputGroup className="mb-3">
            <InputGroup.Text className="form-icon"><FaPhoneAlt /></InputGroup.Text>
            <Form.Control type="tel" placeholder="Enter your number" />
          </InputGroup>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col xs={12} md={6}>
          <InputGroup className="mb-3">
            <InputGroup.Text className="form-icon"><FaEnvelope /></InputGroup.Text>
            <Form.Control type="email" placeholder="Enter your email" />
          </InputGroup>
        </Col>
        <Col xs={12} md={6}>
          <InputGroup className="mb-3">
            <InputGroup.Text className="form-icon"><FaTag /></InputGroup.Text>
            <Form.Control type="text" placeholder="Enter subject" />
          </InputGroup>
        </Col>
      </Row>

      <InputGroup className="mb-4">
        <InputGroup.Text className="form-icon"><FaRegCommentDots /></InputGroup.Text>
        <Form.Control as="textarea" rows={5} placeholder="Write your message" />
      </InputGroup>

      <Form.Group controlId="notification_consent" className="mb-3 contact-consent-check">
        <Form.Check
          type="checkbox"
          label={
            <>
              I hereby authorise to send notifications via SMS, Email, RCS and others as per{' '}
              <a href="terms-conditions" target="_blank" rel="noopener noreferrer">Terms of Service</a>
              /
              <a href="privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              <span className="required"> *</span>
            </>
          }
          checked={notificationConsent}
          onChange={(e) => {
            setNotificationConsent(e.target.checked);
            if (e.target.checked) setConsentError('');
          }}
          isInvalid={!!consentError}
        />
        {consentError && (
          <div className="contact-consent-error">{consentError}</div>
        )}
      </Form.Group>

      <Button type="submit" className="btn-primary btn-send w-100">
        Submit Now
      </Button>
    </Form>
  );
};

export default ContactForm;
